<template>
  <div>
    <div>
      <div class="tasks-title-box w-100 rounded">
        <v-row class="ma-5">
          <v-col class="my-auto mx-auto mobile-d-none"><h3>گزارش ها</h3></v-col>
          <v-col>
            <v-text-field label="جست و جو کنید"
                          placeholder="حداقل ۳ حرف "
                          outlined dir="ltr"
                          class="search-tasks elevation-0"
                           rounded dense
                          v-model="search_field"
                          style="margin-bottom: -25px"
                          clearable
                          @click:clear="search_reports_loaded=false;get_reports()"
                          @keydown.enter="page=1;filter_reports()"
                          :rules="[rules.min_3]">
              <template v-slot:append v-if="search_field && search_field.length>=3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                      <v-icon color="red" v-bind="attrs" v-on="on" @click="page=1;filter_reports()"> mdi-magnify </v-icon>
                  </template>
                  <span>
                    برای جست و جو کلیک کنید.
                  </span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-col>
          <v-col class="text-left" xs="12">
            <v-btn large class="elevation-0" @click="add_report_dialog=true;">
              <v-icon small>mdi-plus</v-icon>
              <div class="mobile-d-none">افزودن</div>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="last-changes rounded-lg container">
      <h2 class="text-center mb-3">گزارش های ثبت شده</h2>
      <v-data-table
          :loading="receiving_data"
          no-data-text="گزارشی پیدا نشد"
          :headers="reports.headers"
          :items="reports.desserts"
          :hide-default-footer="true"
          :items-per-page="reports_length"
          class="elevation-0"
      >

        <template v-slot:item.des="{ item }">
          <v-tooltip v-if="item.des.length>100" top color="gray" max-width="50em">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs"
                 v-on="on">
                {{item.des.slice(0,50)+'...'}}
              </div>
            </template>
            <span>{{item.des}}</span>
          </v-tooltip>
          <div v-else>
            {{item.des}}
          </div>
        </template>
        <template v-slot:item.created_at="{ item }">
          {{new Date(item.created_at.split('T')[0]).toLocaleDateString('fa-IR')}}
          <br>
          {{ convert_en_to_fa_number(item.created_at.split('T')[1].split('.')[0]) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn-toggle class="my-5 rounded-xl" divided>
            <v-btn text color="primary" @click="detail_view.en=true;detail_view.report=item;">
              <v-icon color="primary">
                mdi-eye
              </v-icon>

            </v-btn>
            <v-btn text @click="edit_view.report=item;edit_view.en=true;">
              <v-icon color="warning">
                mdi-pencil
              </v-icon>
            </v-btn>

            <v-btn text color="red" @click="remove_view.report=item;remove_view.dialog=true;">
              <v-icon color="red">
                mdi-delete
              </v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>
          <template v-slot:footer>
            <div v-if="reports_length > 10" class="text-center mt-5">
              <v-pagination
                      v-model="page"
                      color="#D20003"
                      rounded
                      @input="search_field?filter_reports():get_reports()"
                      :length="reports_length%10!==0?parseInt(reports_length/10)+1:parseInt(reports_length/10)"
                      :total-visible="7"
              ></v-pagination>
            </div>
          </template>

      </v-data-table>
    </div>
    <v-dialog v-model="add_report_dialog"  scrollable min-height="20vh" max-width="60em">
      <v-card>
        <v-img v-if="!add_report_btn_loading" class="create-bg" src="../../assets/img/create-reports-bg.svg"></v-img>
        <v-card-title class="mb-5 w-100">
          <v-spacer></v-spacer>
          <h2>افزودن گزارش کار جدید</h2>
          <v-spacer></v-spacer>
          <v-icon
              @click="add_report_dialog=false"
              large
              color="error"
          >
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div v-if="add_report_btn_loading">
              <h2>در حال بارگزاری اطلاعات</h2>
              <br>
              <v-progress-linear
                  class="rounded-lg"
                  max="100" :value="add_report_progress_value" color="error" height="25"
              >
                <strong>{{ Math.ceil(add_report_progress_value) }}%</strong>
              </v-progress-linear>

            </div>
            <v-row v-else>
              <v-col cols="12" sm="12" md="8" lg="6" xl="4">
                <v-text-field v-model="report_form.device_name" outlined label="نام دستگاه"></v-text-field>
              </v-col>
              <v-col sm="12" md="8" lg="6" xl="4"></v-col>
              <v-col cols="12" sm="12" md="8" lg="6" xl="4">
                <v-combobox
                    v-model="report_form.location"
                    :items="locations"
                    outlined  style="border-radius: 5px "
                    placeholder="انتخاب کنید، یا مورد جدیدی بنویسید."
                    label="نام منطقه"
                ></v-combobox>
              </v-col>
              <v-col sm="12" md="8" lg="6" xl="4"></v-col>
              <v-col cols="12" sm="12" md="8" lg="6" xl="4">
                <v-select v-model="report_form.clean_status" outlined label="شستشوی کامل بدنه" :items="['انجام شد']"></v-select>
              </v-col>
              <v-col sm="12" md="8" lg="6" xl="4"></v-col>
              <v-col cols="12" sm="12" md="8" lg="6" xl="4">
                <v-text-field v-model="report_form.city_name" outlined label="نام شهرستان"></v-text-field>
              </v-col>
              <v-col sm="12" md="8" lg="6" xl="4"></v-col>
              <v-col cols="12">
                <v-textarea v-model="report_form.des" outlined label="توضیحات"></v-textarea>
              </v-col>
              <v-col cols="6">
                <v-file-input v-model="report_form.img_before" outlined label="عکس قبل از شستشو"></v-file-input>
              </v-col>
              <v-col cols="6">
                <v-file-input v-model="report_form.img_after" outlined label="عکس بعد از شستشو"></v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="text-left">
          <v-btn color="success"
                 block large
                 class="mx-auto"
                 @click="send_report"
                 :disabled="!(report_form['img_before'] && report_form['img_after'])"
                 :loading="add_report_btn_loading"
          >ثبت گزارش</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ReportDetail :detail_view="detail_view"></ReportDetail>
    <ReportEdit :edit_view="edit_view" @reload="get_reports()"></ReportEdit>

    <v-dialog
        v-model="remove_view.dialog"
        persistent
        max-width="500"
        class="br-1em"
    >
      <v-card class="br-1em">
        <v-card-title>
          <h3 class="mx-auto">
            آیا میخواهید این گزارش را حذف کنید ؟
          </h3>
        </v-card-title>
        <v-card-actions class="text-center pb-5">
          <v-spacer></v-spacer>
          <v-btn
              color="green"
              @click="remove_view.dialog = false"
              large text
              class="elevation-0"
          >
            بازگشت
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn

              color="error"
              class="elevation-0"
              :loading="remove_view.loading"
              :disabled="remove_view.loading"
              @click="remove_report(remove_view.report['id'])"
          >
            حذف
          </v-btn>
          <v-spacer></v-spacer>

        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>

</template>

<script>
import axios from "axios";
import ReportDetail from './reports/detail.vue';
import ReportEdit from './reports/edit.vue';
import create_reports_bg from '../../assets/img/create-reports-bg.svg';


export default {
  name: "Homereport",
  components:{
    ReportDetail,
    ReportEdit,

    // svg:
    create_reports_bg,
  },
  created() {
    this.get_reports();
    this.get_locations();
  },
  data:()=>({
    search_field: null,
    add_report_dialog:false,
    key: localStorage.getItem('key'),
    reports: {
      headers: [
        {text: 'نام دستگاه',align: 'center', value: 'device_name'},
        {text: 'منطقه',sortable: false,align: 'center', value: 'location'},
        {text: 'شرح',sortable: false,align: 'center', value: 'des'},
        {text: 'پرسنل',align: 'center', value: 'created_by.get_full_name'},
        {text: 'زمان',align: 'center', value: 'created_at'},
        {text: 'تغییرات',sortable: false,align: 'center', value: 'actions'},
      ],
      desserts: [],
    },
    detail_view: {en:false, report:{}},
    edit_view: {en: false, report:{}},
    receiving_data:false,
    search_reports_loaded:false,
    add_report_btn_loading:false,
    add_report_progress_value:0,
    report_form:{},
    page:1,
    show_actions:false,
    reports_length:'',
    locations:[],
    remove_view:{
      dialog: false,
      loading:false,
      report:null,
    },
    rules: {
      min_3: v => v.length >= 3 || 'حداقل ۳ حرف',
    },

  }),
  methods:{
    get_locations(){
      this.receiving_data=true;
      axios.get(this.BACKEND_LINK + `/api/tasks/manage/?model=locations`,{
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        this.locations = response.data;
      }).catch(()=>{
        this.$snotify.error('خطا در دریافت اطلاعات.');
        this.receiving_data=false;
      })
    },
    filter_reports(){
      this.receiving_data=true;
      axios.get(this.BACKEND_LINK + `/api/reports/?page=${this.page}&search=${this.search_field}`,{
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        this.reports_length = response.data.count;
        this.reports.desserts = response.data.results;
        this.receiving_data = false;
        this.search_reports_loaded = true;
      }).catch(()=>{
        this.$snotify.error('خطا در جست و جو در گزارشها.');
        this.receiving_data=false;
      })
    },

    get_reports(){
      this.receiving_data=true;
      axios.get(this.BACKEND_LINK + '/api/reports/?page=' + this.page,{
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        this.reports_length = response.data.count;
        this.reports.desserts = response.data.results;
        this.receiving_data=false;
      }).catch(()=>{
        this.$snotify.error('خطا در دریافت گزارشها.');
        this.receiving_data=false;
      })
    },
    remove_report(id){
        this.remove_view.loading = true;
        axios.delete(this.BACKEND_LINK + '/api/reports/' + id, {
          headers: {'Authorization': `Token ${this.key}`}
        }).then(() => {
          this.remove_view.loading = false;
          this.remove_view.dialog = false;
          this.$snotify.success('گزارش با موفقیت حذف شد.', 'حذف گزارش')
          this.get_reports();
        }).catch(() => {
          this.$snotify.error('خطا در حذف گزارش.', 'حذف گزارش')
        })
    },
    send_report(){
      this.add_report_btn_loading = true;
        const report = new FormData();
        report.append("device_name", this.report_form.device_name);
        report.append("location", this.report_form.location);
        report.append("clean_status", 'D');
        report.append("city_name", this.report_form.city_name);
        report.append("des", this.report_form.des);
        report.append("img_before", this.report_form.img_before);
        report.append("img_after", this.report_form.img_after);

      axios.post(this.BACKEND_LINK + '/api/reports/',report,{
        onUploadProgress: progressEvent => this.add_report_progress_value = (progressEvent.loaded / progressEvent.total) * 100 ,
        headers: {'Authorization': `Token ${this.key}`}
      }).then(()=>{
        this.report_form = {};
        this.$snotify.success('گزارش با موفقیت ثبت شد.', 'ثبت گزارش')
        this.get_reports();
        this.add_report_dialog = false;

      }).catch(()=>{
        this.$snotify.error('خطا در ثبت گزارش.', 'ثبت گزارش')
      }).finally(()=>{
        this.add_report_btn_loading = false;
      })

    },
  }
}
</script>

<style scoped>
.create-bg{
  left: 0;
  top: 5em;
  position: absolute;
  opacity: 1;
}

</style>
